<script lang="ts" setup>
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  hasOffset?: boolean;
}

defineProps<Props>();
</script>

<template>
  <div class="secondary-nav" :class="classNames({ hasOffset })">
    <slot />
  </div>
</template>

<style lang="scss">
@use './SecondaryNav.scss';
</style>
